import { Option } from "./Auswahl";

export function Togglebutton({
  options,
  name,
  value,
  onChange,
}: {
  options: Option[];
  name: string;
  value: Option;
  onChange: (value: Option) => void;
}) {
  return (
    <div className="togglebutton" role="radiogroup" aria-label={name}>
      {options.map((option) => {
        const { label, isDisabled } = option;
        const isActive = value === option;
        return (
          <label
            key={option.value}
            //  ► Bootstrap-Klasse weg, dafür aktiv/selektierbar setzen
            className={`togglebutton__option ${
              isActive ? "togglebutton__option--active" : "togglebutton__option--selectable"
            }`}
          >
            {/* Radio bleibt für Barriere­freiheit, ist aber unsichtbar */}
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={isActive}
              onChange={() => onChange(option)}
              disabled={isDisabled}
            />
            {/* Sichtbarer Teil – kann dein Dropdown-Markup enthalten */}
            <div className="dropdown-entry">{label}</div>
          </label>
        );
      })}
    </div>
  );
}
